import type { StatusOption } from '@/components/common';

export type NoteType = 'general' | 'rehearsal' | 'meeting';

export const DEFAULT_NOTE_TYPE: NoteType = 'general';

export const NOTE_TYPE_OPTIONS = [
    { value: 'general', label: 'General', variant: 'secondary', icon: 'article' },
    { value: 'rehearsal', label: 'Rehearsal', variant: 'purple', icon: 'theater_comedy' },
    { value: 'meeting', label: 'Meeting', variant: 'indigo', icon: 'groups' },
] satisfies StatusOption<NoteType>[];

export function normalizeNoteType(value: unknown): NoteType {
    if (typeof value !== 'string') {
        return DEFAULT_NOTE_TYPE;
    }

    switch (value.trim().toLowerCase()) {
        case 'rehearsal':
            return 'rehearsal';
        case 'meeting':
            return 'meeting';
        case 'general':
            return 'general';
        default:
            return DEFAULT_NOTE_TYPE;
    }
}

export function formatNoteType(value: unknown): string {
    const noteType = normalizeNoteType(value);
    return NOTE_TYPE_OPTIONS.find(option => option.value === noteType)?.label ?? 'General';
}
